import { LUBAV_API_URL } from '@backrs_ui/grow-ui/src/settings';

import { getLubavAccessToken } from '../baseQuery';
import { store } from '../store';

// Comfortably past the server's own budget, so this only fires on a stalled
// connection rather than cutting off a response still on its way.
const REQUEST_TIMEOUT_MS = 90 * 1000;

/** Returns the recognised speech, empty when nothing was said. */
export const transcribeAudio = async (audio: Blob): Promise<string> => {
  const token = getLubavAccessToken(store.getState());

  if (!token) {
    throw new Error('Cannot transcribe audio without an access token');
  }

  const formData = new FormData();

  formData.append('file', audio, 'recording');

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

  let response: Response;

  try {
    response = await fetch(`${LUBAV_API_URL}/api/transcribe-audio`, {
      method: 'POST',
      headers: {
        authorization: `Bearer ${token}`,
        accept: 'application/json',
      },
      body: formData,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timeout);
  }

  if (!response.ok) {
    throw new Error(`Failed to transcribe audio (${response.status} ${response.statusText})`);
  }

  const body: unknown = await response.json();
  const text = (body as { text?: unknown })?.text;

  if (typeof text !== 'string') {
    throw new Error('Transcription response did not include text');
  }

  return text;
};
